<template>
  <div class="home-container pr-40 pl-40">
    <StarryBackground />
    <div class="content-wrapper">
      <CoursesList/>
      <div class="mt-5">
        <TutorialsList/>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../../../services/user/user.service.js";
import TutorialsList from "../tutorials/TutorialsList.vue";
import CoursesList from "../courses/course/CoursesList.vue";
import StarryBackground from "../../common/StarryBackground.vue";

export default {
  name: "Home",
  components: {
    CoursesList,
    TutorialsList,
    StarryBackground
  },
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    // Сбрасываем позицию скролла при монтировании компонента
    window.scrollTo(0, 0);

    UserService.getPublicContent().then(
        (response) => {
          this.content = response.data;
        },
        (error) => {
          this.content =
              (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
              error.message ||
              error.toString();
        }
    );
  },
};
</script>

<style scoped>
.home-container {
  padding-bottom: 30px;
  position: relative;
}

.content-wrapper {
  position: relative;
  z-index: 1;
  padding: 0 0 20px 0;
}

.home-card {
  border-radius: 17px;
  margin-top: 10px;
  background: linear-gradient(130deg, var(--my-links), #005bb5);
  padding: 20px;
  position: relative;
}

@media (max-width: 768px) {
  .home-container {
    min-height: 100vh;
    flex-direction: column;
    gap: 0;
  }
}
</style>
